













import { defineComponent } from 'vue-demi';

const name = 'audienceSize';
export default defineComponent({
  name,
  components: {},
  props: {
    loadingETA: {
      type: Boolean,
      default: false,
    },
    userCount: {
      type: String,
      default: '',
    },
  },
  setup() {
    return {
      name,
    };
  },
});
